import { BackendResponseStatus } from "./backend-response-status.enum";

export class BackendResponseItem {
    constructor(public status: BackendResponseStatus, public message: string, public errorId = 0, public recoverable = true) {
    }
}
